export default {
  SET_ONE_APARTMENT(state, data) {
    state.single_apartment = { ...data }
  },
  SET_APARTMENTS(state, data) {
    state.apartments = data
  },
  SET_APARTMENT_CHECKERBOARD_LAYOUT(state, data) {
    state.checkerboard_layout = data
  },
  SET_FLATS_PLANNINGS_BY_APARTMENT(state, data) {
    state.flat_plannings_by_apartment = data
  },
  SET_ROOMS_COUNT_BY_APARTMENT(state, data) {
    state.rooms_count_by_apartment = data
  },
  SET_BADGES(state, data) {
    state.badges = data
  },
}
